module.exports = __webpack_public_path__ + "static/media/43.9fb4f420.png";